export default __webpack_public_path__ + "static/media/placeholder.7e546eda.svg";